import { CREME, ORANGE, pluriel } from './dossierUi'

/**
 * Etat du dossier en tete de page (prototype v7.5) : carte glass-dark, titre
 * selon le niveau, une barre par etape, ligne « Il manque : … ».
 */
function EtatDossierCarte({ etat }) {
  const n = etat.manquants.length
  const complet = etat.niveau === 'COMPLET'
  return (
    <div className="glass-dark rounded-[28px] relative overflow-hidden" style={{ padding: '22px 20px', color: CREME }}>
      <div className="absolute rounded-full pointer-events-none" style={{
        top: -40, right: -40, width: 160, height: 160,
        background: `radial-gradient(circle, ${complet ? 'rgba(20,184,166,0.45)' : 'rgba(244,137,83,0.4)'}, transparent 70%)`,
      }} />
      <div className="relative">
        <p className="text-[10px] uppercase font-extrabold" style={{ letterSpacing: 2.4, color: 'rgba(247,240,234,0.7)' }}>📋 Dossier exposant</p>
        <p className="font-serif text-[26px] mt-1.5 leading-[1.15]">
          {etat.niveau === 'INCOMPLET' ? `${pluriel(n, 'élément')} à fournir`
            : etat.niveau === 'VERIFICATION' ? 'En cours de vérification' : 'Dossier complet ✓'}
        </p>
        <p className="text-[12.5px] mt-1.5 leading-normal" style={{ color: 'rgba(247,240,234,0.78)' }}>
          {etat.niveau === 'INCOMPLET'
            ? "La mairie l'exige pour autoriser le marché : chaque exposant doit être identifiable et assuré."
            : etat.niveau === 'VERIFICATION'
              ? "L'équipe Manrina vérifie vos pièces sous 48-72h. Vos inscriptions aux évènements restent ouvertes."
              : "Vos pièces sont validées. Pensez à renouveler votre attestation d'assurance à son échéance."}
        </p>
        <div className="flex gap-1 mt-3.5">
          {etat.etapes.map((e) => (
            <div key={e.code} className="flex-1 h-[5px] rounded-full" style={{ background: e.ok ? ORANGE : 'rgba(247,240,234,0.2)' }} />
          ))}
        </div>
        {n > 0 && (
          <p className="text-[11.5px] mt-2.5 leading-normal" style={{ color: 'rgba(247,240,234,0.7)' }}>
            Il manque : {etat.manquants.map((m) => m.libelle).join(' · ')}
          </p>
        )}
      </div>
    </div>
  )
}

export default EtatDossierCarte
